import { StreetAddressField } from './components/StreetAddressField';
import { StreetAddress2Field } from './components/StreetAddress2Field';
import { CityField } from './components/CityField';
import { StateField } from './components/StateField';
import { ZipCodeField } from './components/ZipCodeField';
import { PhoneNumberAField } from './components/PhoneNumberAField';
import { PhoneNumberATypeField } from './components/PhoneNumberATypeField';
import { PhoneNumberBField } from './components/PhoneNumberBField';
import { PhoneNumberBTypeField } from './components/PhoneNumberBTypeField';
import { EmailField } from './components/EmailField';
import { SecondaryEmailField } from './components/SecondaryEmailField';

interface ContactAddressSectionProps {
    readOnlyPrimaryEmail?: boolean;
    showPrimaryEmailWarning?: boolean;
    maxPhoneFieldColumns?: number | undefined;
}

export const ContactAddressSection: React.FC<ContactAddressSectionProps> = ({
    readOnlyPrimaryEmail = false,
    showPrimaryEmailWarning = true,
    maxPhoneFieldColumns = 4,
}) => {
    return (
        <>
            <h2 className='decorated'>Contact Address</h2>
            <div className='field-section'>
                <div className='field-row'>
                    <StreetAddressField />
                    <StreetAddress2Field />
                </div>
                <div className='field-row'>
                    <CityField />
                    <StateField />
                    <ZipCodeField />
                </div>
            </div>
            <br />
            <div className='field-section'>
                <div
                    className='field-row'
                    style={{ '--cols': maxPhoneFieldColumns } as React.CSSProperties}
                >
                    <PhoneNumberAField />
                    <PhoneNumberATypeField />
                    <PhoneNumberBField />
                    <PhoneNumberBTypeField />
                </div>
            </div>
            <br />
            <div className='field-section'>
                <div className='field-row'>
                    <EmailField
                        readOnly={readOnlyPrimaryEmail}
                        showWarning={showPrimaryEmailWarning}
                    />
                    <SecondaryEmailField />
                </div>
            </div>
        </>
    );
};
